import { gql } from "generated/gql"

export const CREATE_DATA_GRID_SAVED_REPORT_MUTATION = gql(`
  mutation CreateDataGridSavedReport(
    $name: String!
    $userId: ID!
    $reportKey: String!
    $reportConfig: DataGridSavedReportConfigInput!
  ) {
    mutationResult:createDataGridSavedReport(input: {
      name: $name
      userId: $userId
      reportKey: $reportKey
      reportConfig: $reportConfig
    }) {
      id
      errors
      savedReport {
        ...SavedReportFields
      }
    }
  }
`)

export const UPDATE_DATA_GRID_SAVED_REPORT_MUTATION = gql(`
  mutation UpdateDataGridSavedReport(
    $id: ID!
    $name: String
    $userId: ID
    $reportConfig: DataGridSavedReportConfigInput
  ) {
    mutationResult:updateDataGridSavedReport(input: {
      id: $id
      name: $name
      userId: $userId
      reportConfig: $reportConfig
    }) {
      id
      errors
      savedReport {
        ...SavedReportFields
      }
    }
  }
`)

export const DESTROY_DATA_GRID_SAVED_REPORT_MUTATION = gql(`
  mutation DestroyDataGridSavedReport(
    $id: ID!
  ) {
    mutationResult:destroyDataGridSavedReport (input: {
      id: $id
    }) {
      id
      errors
      savedReport {
        ...SavedReportFields
      }
    }
  }
`)
